/* @flow */
import * as React from 'react';
import Slider from 'react-slick';

import IconButton from '../IconButton';

type Props = {
  disabled?: boolean,
  loading?: boolean,
  submit?: boolean,
  text?: string,
  onClick?: () => mixed,
};

type PrevArrowProps = {
  className?: string,
  style?: Object,
  onClick?: () => mixed,
};
const PrevArrow = ({ className, style, onClick }: PrevArrowProps) => (
  <IconButton
    icon={'chevron_left'}
    onClick={onClick}
    className={className}
    style={{ ...style, position: 'absolute', top: '50%', left: '-18px' }}
  />
);

type NextArrowProps = {
  className?: string,
  style?: Object,
  onClick?: () => mixed,
};
const NextArrow = ({ className, style, onClick }: NextArrowProps) => (
  <IconButton
    icon={'chevron_right'}
    onClick={onClick}
    className={className}
    style={{
      ...style,
      position: 'absolute',
      top: '50%',
      right: '-18px',
    }}
  />
);

export default (props: Props): React$Element<any> => (
  <Slider {...props} prevArrow={<PrevArrow />} nextArrow={<NextArrow />} />
);
